var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-grid__item m-aside-left m-aside-left--skin-dark",
      attrs: { id: "m_aside_left" }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "m-aside-menu m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark",
          attrs: {
            id: "m_ver_menu",
            "data-menu-vertical": "true",
            "data-menu-scrollable": "false",
            "data-menu-dropdown-timeout": "500"
          }
        },
        [
          _c(
            "ul",
            { staticClass: "m-menu__nav m-menu__nav--dropdown-submenu-arrow" },
            _vm._l(_vm.all_sections.sections, function(section, index) {
              return _c(
                "s-menu",
                {
                  key: section.id,
                  attrs: {
                    name: section.name,
                    icon: section.icon,
                    link: section.route,
                    submenu:
                      _vm.all_sections.children[section.id].length > 0
                        ? true
                        : false,
                    index: index,
                    section: section.id
                  }
                },
                [
                  _c(
                    "ul",
                    {
                      staticClass: "m-menu__subnav",
                      attrs: { slot: "submenu" },
                      slot: "submenu"
                    },
                    _vm._l(_vm.all_sections.children[section.id], function(
                      submenu
                    ) {
                      return _c("s-submenu", {
                        key: submenu.id,
                        attrs: {
                          features: _vm.features,
                          name: submenu.name,
                          link: submenu.route
                        },
                        on: {
                          click: function($event) {
                            return _vm.location(submenu.route)
                          }
                        }
                      })
                    }),
                    1
                  )
                ]
              )
            }),
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd9fc21e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd9fc21e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/layout/sidebar/Base.vue
// module id = 785
// module chunks = 0 54 76